(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sg-lp-auto-signals"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sg-auto-signals')) {
  customElements.define('sg-auto-signals', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.viewport = this.querySelector('.sg-auto-signals__viewport');
      this.track = this.querySelector('.sg-auto-signals__track');
      this.list = this.track.querySelector('ul');
      this.button = this.querySelector('button');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true';
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.clone = this.list.cloneNode(true);
      this.clone.setAttribute('aria-hidden', 'true');
      this.clone.setAttribute('inert', '');
      this.clone.setAttribute('data-sg-signal-clone', '');
      this.track.append(this.clone);
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.clone.hidden = this.motion.matches || this.dataset.autoplay !== 'true';
        this.button.hidden = this.motion.matches || this.dataset.autoplay !== 'true';
        this.button.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
        this.button.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
        this.previous = null;
        if (!this.paused && !this.motion.matches && this.visible && !this.hovered && !this.focused && !document.hidden) this.frame = requestAnimationFrame(this.tick);
      };
      this.tick = time => {
        const width = this.list.getBoundingClientRect().width;
        if (this.previous !== null && width > 0) {
          this.position += Math.min(time - this.previous, 50) * 0.03;
          if (this.position >= width) this.position %= width;
          this.viewport.scrollLeft = this.position;
        } else this.position = this.viewport.scrollLeft;
        this.previous = time;
        this.frame = requestAnimationFrame(this.tick);
      };
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.refresh(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.refresh(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.refresh(); }, options);
      this.viewport.addEventListener('focusin', () => { this.focused = true; this.refresh(); }, options);
      this.viewport.addEventListener('focusout', event => { this.focused = this.viewport.contains(event.relatedTarget); this.refresh(); }, options);
      const pause = () => { this.paused = true; this.refresh(); };
      this.viewport.addEventListener('pointerdown', pause, options);
      this.viewport.addEventListener('wheel', pause, { ...options, passive: true });
      this.motion.addEventListener('change', () => { this.viewport.scrollLeft = 0; this.refresh(); }, options);
      document.addEventListener('visibilitychange', this.refresh, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.refresh(); });
      this.observer.observe(this);
      this.refresh();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
      this.clone?.remove();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vqs-trust-signals"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-trust-pause]');
  if (!button) return;
  const paused = button.closest('.vqs-brand-signals').classList.toggle('is-paused');
  button.setAttribute('aria-pressed', String(paused));
  button.setAttribute('aria-label', paused ? 'Resume trust signals' : 'Pause trust signals');
  button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
});
  } catch(e) { console.error(e); }
})();

})();
